import Vue from 'vue'
import VeeValidate, { Validator } from 'vee-validate'
import DictionaryES from './locales/es/es'

Vue.use(VeeValidate, { events: '' })
Validator.localize('es', DictionaryES)
